import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import HostNavLinks from '../host/HostNavLinks';

import useOmeMeetData from '../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryData from '../../state/omeMeetEntry/UseOmeMeetEntryData';
import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';

const useOmeMeetTemplateSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { omeMeetState, getOmeMeet } = useOmeMeetData();
  const { omeMeetEntryState, getOmeMeetEntry } = useOmeMeetEntryData();
  const { meetState, getMeet } = useMeetData();
  const { searchMeetState } = useSearchMeetData();
  const [state, setState] = useState({ tryRedirect: false });

  const onCancelClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    navigate(HostNavLinks.OME_MEET_TEMPLATE_LANDING, {
      state: {
        meetId: location.state?.meetId, meetFiltersState: location.state?.meetFiltersState, route: location.state?.route
      }
    });
  };

  const onEditClicked = (e, meet) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    getOmeMeet(meet.omeMeetId);
    getOmeMeetEntry(meet.omeMeetId);
    getMeet(meet.meetId);
    setState({ ...state, tryRedirect: true });
  }

  useEffect(() => {
    if (state.tryRedirect === true && omeMeetState.isObjLoading === false && meetState.isObjLoading === false && omeMeetEntryState.isObjLoading === false) {
      navigate(HostNavLinks.OME_MEET_TEMPLATE_LANDING, {
        state: {
          meetId: location.state?.meetId, meetFiltersState: location.state?.meetFiltersState, route: location.state?.route
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, omeMeetState.isObjLoading, meetState.isObjLoading, omeMeetEntryState.isObjLoading])

  return {
    omeMeetState,
    omeMeetEntryState,
    meetState,
    searchMeetState,
    onEditClicked,
    onCancelClicked
  };
};

export default useOmeMeetTemplateSearch;